import { Variant } from 'lib/product';
import { AddonOptionValue, Ingredient } from 'lib/productAddon';
import {
  multiplyNutritionalValue,
  sumNutritionalValues,
} from './utils';

export const calculateProductVariantNutritionalValue = (
  productVariant: Variant | null,
) => productVariant?.nutrition?.constant;

const calculateIngredientNutritionalValue = (
  ingredient: Ingredient | undefined,
  portion: number,
) => {
  if (!ingredient?.nutrition) return {};

  const {
    constant,
    proportional,
    base_portion,
  } = ingredient.nutrition;

  return sumNutritionalValues(
    constant,
    multiplyNutritionalValue(proportional, portion / base_portion),
  );
};

const calculateAddonOptionValueNutritionalValue = (
  addonOptionValue: AddonOptionValue,
  selectIngredientById?: (id: string) => Ingredient | undefined,
) => {
  if (!addonOptionValue || !selectIngredientById) return {};

  const {
    ingredient: ingredientId,
    consume_quantity,
  } = addonOptionValue;

  const ingredient = selectIngredientById(String(ingredientId));

  return calculateIngredientNutritionalValue(
    ingredient,
    consume_quantity,
  );
};

export const calculateNutritionalValues = (
  productVariant: Variant | null,
  addonOptionValues?: AddonOptionValue[],
  selectIngredientById?: (id: string) => Ingredient | undefined,
) => {
  const baseNutritionalValue = calculateProductVariantNutritionalValue(
    productVariant,
  );

  if (!addonOptionValues?.length) {
    return sumNutritionalValues(baseNutritionalValue);
  }

  const addonOptionsNutritionalValue = addonOptionValues?.reduce(
    (result, addonOptionValue) => {
      result = sumNutritionalValues(
        result,
        calculateAddonOptionValueNutritionalValue(
          addonOptionValue,
          selectIngredientById,
        ),
      );

      return result;
    },
    {},
  );

  const productVariantNutritionalValue = calculateProductVariantNutritionalValue(
    productVariant,
  );

  return sumNutritionalValues(
    addonOptionsNutritionalValue,
    productVariantNutritionalValue,
  );
};
